import React, { forwardRef } from 'react';

import { Box, Typography, useTheme } from '@mui/material';

import { CalendarIcon } from '@setup/svg-icons/svg-icons';
import { formatDateForView } from '@shared/utils/formatDateForView';
import { InputError } from 'shared/ui-kit';

type DatePickerInputProps = {
  isDisabled?: boolean;
  isClearable?: boolean;
  dateFormat?: string;
  isLate?: boolean;
  placeholder?: string;
  isShowIcon?: boolean;
  isReadOnly?: boolean;
  value?: any;
  [x: string]: any;
};

const DatePickerIconButtonVariant = forwardRef<HTMLHeadingElement, DatePickerInputProps>((props, ref) => {
  const {
    isShowPopup,
    isLate,
    value,
    placeholder,
    dateFormat,
    errorMessage,
    isError,
    isShowIcon,
    isDisabled,
    isReadOnly,
  } = props;
  const theme = useTheme();

  return (
    <Box>
      <Box
        ref={ref}
        sx={{
          cursor: isDisabled || isReadOnly ? 'initial' : 'pointer',
          display: 'flex',
          height: '32px',
          alignItems: 'center',
          backgroundColor: isError
            ? theme.palette.case.red.r100
            : isShowPopup
              ? theme.palette.case.neutral.n100
              : 'transparent',
          padding: '6px',
          borderRadius: '6px',
          transition: 'all 0.3s ease',
          userSelect: 'none',
          '&:hover': { backgroundColor: theme.palette.case.neutral.n75 },
          '&:active': { backgroundColor: theme.palette.case.neutral.n100 },
        }}
      >
        {isShowIcon && (
          <Box
            sx={{
              mr: '8px',
              svg: {
                width: '16px',
                height: '16px',
                path: {
                  fill: isLate ? theme.palette.case.red.r500 : theme.palette.case.neutral.n500,
                },
              },
            }}
          >
            <CalendarIcon />
          </Box>
        )}

        {value && (
          <Typography
            pt="2px"
            color={isLate ? theme.palette.case.red.r500 : theme.palette.case.neutral.n900}
            lineHeight="22px"
            variant="t14m"
          >
            {formatDateForView(value, dateFormat || 'h:mm A')}
          </Typography>
        )}
        {!value && placeholder && (
          <Typography pt="2px" color={theme.palette.case.neutral.n500} lineHeight={'22px'} variant="t14r">
            {placeholder}
          </Typography>
        )}
      </Box>
      {errorMessage ? <InputError isShow={isError} message={errorMessage} /> : <></>}
    </Box>
  );
});

export default DatePickerIconButtonVariant;
